
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const UserCreationExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col">Sr No.</th>
                        <th>Role</th>
                        {/* <th>Department Name</th> */}
                        <th>Designation</th>
                        <th>Employee Name</th>
                        <th>Table User Name</th>
                        <th>User Name</th>
                        <th>Password</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td>{item.m_RoleName ? item.m_RoleName : '-'}</td>
                                    {/* <td></td> */}
                                    <td>{item.designationName ? item.designationName : '-'}</td>
                                    <td>{item.employeeName ? item.employeeName : '-'}</td>
                                    <td>{item.tableUserName ? item.tableUserName : '-'}</td>
                                    <td>{item.userName ? item.userName : '-'}</td>
                                    <td>{item.password ? item.password : '-'}</td>
                                    <td>{item.statusName ? item.statusName : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}